var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankyouIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9999 31.9769C52 41.9867 44.4605 51.412 33.8811 53.518C28.7214 54.5467 23.369 53.9195 18.586 51.7258C13.8031 49.5322 9.83339 45.8839 7.24224 41.3004C4.65109 36.7169 3.57055 31.4319 4.15448 26.1979C4.73841 20.9639 6.95704 16.0477 10.4945 12.1494C17.75 4.14955 30.0013 1.94739 40.0007 5.95132",
    stroke: "#24B032",
    strokeWidth: 6.03158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.002 27.9728L30.0014 37.9826L53.9999 11.957",
    stroke: "#24B032",
    strokeWidth: 6.03158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyouIcon);
export default __webpack_public_path__ + "static/media/thankyouIcon.fd76530333561fcf2ac1bad960a25c39.svg";
export { ForwardRef as ReactComponent };